//Danish
const messages = {
};
module.exports = messages;
